export default "__VITE_ASSET__DlNfBXgu__"